import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9697 4.96973C14.6408 4.29864 15.5509 3.92163 16.5 3.92163C17.4491 3.92163 18.3592 4.29864 19.0303 4.96973C19.7014 5.64081 20.0784 6.551 20.0784 7.50006C20.0784 8.44912 19.7014 9.3593 19.0303 10.0304L8.53033 20.5304C8.38968 20.671 8.19891 20.7501 8 20.7501H4C3.58579 20.7501 3.25 20.4143 3.25 20.0001V16.0001C3.25 15.8011 3.32902 15.6104 3.46967 15.4697L12.9641 5.97531C12.9659 5.97342 12.9678 5.97154 12.9697 5.96967C12.9715 5.9678 12.9734 5.96594 12.9753 5.96409L13.9697 4.96973ZM13.5 7.56069L4.75 16.3107V19.2501H7.68934L16.4394 10.5L13.5 7.56069ZM17.5 9.43937L14.5607 6.50003L15.0303 6.03039C15.4201 5.64061 15.9488 5.42163 16.5 5.42163C17.0512 5.42163 17.5799 5.64061 17.9697 6.03039C18.3595 6.42017 18.5784 6.94882 18.5784 7.50006C18.5784 8.05129 18.3595 8.57995 17.9697 8.96973L17.5 9.43937Z"
        fill="currentcolor"
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-pencil" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
